import React, { useEffect } from "react";
import Joi from "joi-browser";
import useControls from "../../app/hooks/useControls";
import useForm from "../../app/hooks/useForm";

const LoginStep2 = ({ handleDoSubmit, userError, type, handleForgotPwd, isProcessing }) => {
  const schema = {
    username: Joi.string().required().label("Username"),
    password: Joi.string().required().label("Password"),
  };

  const doSubmit = () => {
    handleDoSubmit(stateData);
  };

  const {
    stateData,
    setStateData,
    stateErrors,
    setStateErrors,
    handleChange,
    validate,
    handleSubmit,
  } = useForm(schema, doSubmit);

  useEffect(() => {
    if (userError !== undefined) {
      setStateErrors((prev) => ({
        ...prev,
        username: userError,
      }));
    }
  }, [userError, setStateErrors]);

  const { renderInput } = useControls(
    stateData,
    stateErrors,
    handleChange,
    schema
  );

  return (
    <React.Fragment>
      <div>
        {renderInput("username", "Enter Your Username")}

        {renderInput("password", "Enter Your Password", "password")}

        <div>
          <button
            className="btn w-100 wf-login-btn-primary"
            disabled={Boolean(validate()) || isProcessing}
            onClick={handleSubmit}
          >
            {isProcessing ? (
              <React.Fragment>
                <i className="fa fa-refresh fa-spin mr-2" aria-hidden="true"></i>
                Signing In...
              </React.Fragment>
            ) : (
              <React.Fragment>
                <i className="fa fa-sign-in mr-2" aria-hidden="true"></i>
                Sign In
              </React.Fragment>
            )}
          </button>
        </div>

        <div className="mt-3 text-right">
          <button
            onClick={handleForgotPwd}
            className="btn btn-link btn-sm login-link p-0"
            style={{ border: "none", background: "none" }}
            disabled={isProcessing}
          >
            Forgot Username/Password?
          </button>
        </div>

      </div>
    </React.Fragment>
  );
};

export default LoginStep2;
